import { SizeableRoundedDialog } from 'library';
import { ITeacher } from 'models';
import React from 'react';
import EditOrCreateNewJob from './EditOrCreateNewJob';
import InviteWorkersToJob from './InviteWorkersToJob';
import InviteSuccess from './InviteSuccess';

export enum Selections {
    Invite = 'invite',
    Create = 'create',
}

enum Pages {
    ChooseSelection,
    ChooseJob,
    InviteSuccess,
}

export default function EditOrCreateNewJobModal({
    open,
    onClose,
    selectedWorkers,
    openJobForm,
}: {
    open: boolean;
    onClose: () => void;
    selectedWorkers: ITeacher[];
    openJobForm: () => void;
}) {
    const [page, setPage] = React.useState(Pages.ChooseSelection);

    function goToNext(selection: Selections) {
        if (selection === Selections.Invite) {
            setPage(Pages.ChooseJob);
        } else {
            openJobForm();
            resetAndClose();
        }
    }

    function resetAndClose() {
        setPage(Pages.ChooseSelection);
        onClose();
    }

    return (
        <SizeableRoundedDialog
            open={open}
            onClose={resetAndClose}
            style={{
                width: '60%',
                maxWidth: 800,
                maxHeight: '95vh',
                height: '60%',
                display: 'flex',
                flexDirection: 'column',
            }}
            contentStyle={{ marginTop: 20, padding: 40, display: 'flex', flexDirection: 'column' }}
            closeButton
        >
            {page === Pages.ChooseSelection ? (
                <EditOrCreateNewJob goToNext={goToNext} selectedWorkers={selectedWorkers} />
            ) : page == Pages.ChooseJob ? (
                <InviteWorkersToJob
                    selectedWorkers={selectedWorkers}
                    goBack={() => setPage(Pages.ChooseSelection)}
                    onSubmit={() => setPage(Pages.InviteSuccess)}
                />
            ) : (
                <InviteSuccess selectedWorkers={selectedWorkers} onClose={resetAndClose} />
            )}
        </SizeableRoundedDialog>
    );
}
